export const defaultPerPageOptions = [10, 25, 50, 100];
